import { render, staticRenderFns } from "./uploadsolutionform.html?vue&type=template&id=59f85a61&scoped=true&"
import script from "./uploadsolutionform.js?vue&type=script&lang=js&"
export * from "./uploadsolutionform.js?vue&type=script&lang=js&"
import style0 from "./uploadsolutionform.css?vue&type=style&index=0&id=59f85a61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f85a61",
  null
  
)

export default component.exports